import { useUserCreatorData } from 'root/src/client/logic/auth/hooks/useUser';
import { useBestAvailablePlatformToken } from 'root/src/client/logic/dropEvent/hooks/useBestPlatform';
import { isDarePlatform } from 'root/src/shared/platforms/guards/platform.guards';
import { getClassifiedDarePlatform } from 'root/src/shared/drops/helpers/dropDare.helpers';
export function useDareAssignee({ dare, fallbackDrop }) {
    const { tokens } = useUserCreatorData();
    const bestPlatformToken = useBestAvailablePlatformToken(fallbackDrop);
    if (bestPlatformToken && isDarePlatform(bestPlatformToken.platform) && dare.platforms.includes(bestPlatformToken.platform)) {
        return { id: bestPlatformToken.platformId, platform: bestPlatformToken.platform };
    }
    const darePlatformsClassified = dare.platforms.map(getClassifiedDarePlatform);
    // tokens are sorted by the fact if they appear in the dare
    const tokensSorted = tokens === null || tokens === void 0 ? void 0 : tokens.sort((a, b) => {
        const aInPlatforms = darePlatformsClassified.includes(a.platform);
        const bInPlatforms = darePlatformsClassified.includes(b.platform);
        if (aInPlatforms && bInPlatforms) {
            return 0;
        }
        if (aInPlatforms && !bInPlatforms) {
            return -1;
        }
        return 1;
    });
    const matchingPlatform = tokensSorted === null || tokensSorted === void 0 ? void 0 : tokensSorted.find((token) => {
        return darePlatformsClassified.some((darePlatformClassified) => {
            if (!darePlatformClassified) {
                return true;
            }
            return token.platform === darePlatformClassified;
        });
    });
    if (!matchingPlatform) {
        return null;
    }
    return { id: matchingPlatform.platformId, platform: matchingPlatform.platform };
}
